<template>
  <div class="product" v-bind:class="{ disabled: arsenal_model == 'Standard' && upgraded_to_pro }">
    <div class="product-info-row">
      <div class="image-and-name">
        <div class="image-and-info">
          <img :src="require(`app/assets/images/Arsenal-2-${arsenal_model}-thumb.jpg`)" />
        </div>
        <div class="name">
          <div v-if="show_arsenal_model">
            <span v-if="false" class="product-type">Arsenal 2</span><br v-if="false" />
            <span v-if="false" class="product-model">{{ arsenal_model }}</span>
            <span class="product-name">{{ product_name }}</span>
          </div>
          <div v-if="!show_arsenal_model">
            <span class="product-name">Arsenal 2</span>
          </div>

          <div class="product-description">
            <slot></slot>
          </div>
        </div>
      </div>
      <div class="price-and-quantity">
        <div class="price">
          <span class="retail-price" v-if="show_retail_price">{{format_currency(prices.retail)}}</span>
          <span v-if="show_upgrade_button && arsenal_model == 'Pro'" class="sale-price">
            + {{ format_currency(upgrade_price) }}
          </span>
          <span v-else class="sale-price">{{ format_currency(prices.sale) }}</span>
          <span class="discount" v-if="prices.sale < prices.retail">
            {{discount_label}}
          </span>
          <span class="discount" v-if="prices.sale < prices.retail">
            (Save {{ format_currency(prices.retail - prices.sale) }})
          </span>
          <span v-if="show_upgrade_button && arsenal_model == 'Pro'">
            <a class="details" @click.prevent="open_upgrade_details_modal">ⓘ DETAILS</a>
            <ProductDetailsModal :show='show_upgrade_details_modal' :cancel='close_upgrade_details_modal'>
              <slot name="upgrade-modal-content"></slot>
              <template v-slot:actions>
                <a @click.prevent='close_upgrade_details_modal' class='btn btn-cancel'>No Thanks</a>
                <a @click.prevent='upgrade_and_close_modal' class='btn'>Upgrade</a>
              </template>
            </ProductDetailsModal>
          </span>
        </div>

        <div class="upgrade-text" v-if="show_upgrade_button">
          <span v-if="upgraded_to_pro">
            <span v-if="arsenal_model == 'Standard'" class="standard">Upgraded to Pro</span>
            <span v-if="arsenal_model == 'Pro'">Upgraded!</span>
            <a @click.prevent="downgrade_to_standard">(undo)</a>
          </span>
          <button v-if="arsenal_model == 'Pro' && !upgraded_to_pro" @click.prevent="upgrade_to_pro">Upgrade</button>
        </div>

        <div v-if="show_add_product_button">
          <AddProductButton
            :added="added_this_arsenal"
            :quantity="arsenal.quantity"
            :min_limit="minimum_quantity"
            v-on:update_quantity="update_arsenal_quantity"
          />
        </div>
      </div>
    </div>
    <div class="cables" v-if="added_this_arsenal && !disable_cable_select">
      <h4>Choose Your Cable</h4>

      <Cables :variant="variant" :arsenal_version="2" :arsenal="arsenal" :$v="$v" />
    </div>
  </div>
</template>

<script>
import AddProductButton from "app/components/orders/AddProductButton";
import Cables from "app/components/orders/Cables";
import ProductDetailsModal from 'app/components/orders/ProductDetailsModal';
import { format_currency } from "app/helpers/CurrencyHelpers";
import max from "lodash/max";
import times from "lodash/times";

export default {
  props: [
    "arsenal",
    "arsenal_model",
    "show_arsenal_model",
    "prices",
    "$v",
    "discount_label",
    "min_limit",
    "limit",
    "disable_cable_select",
    "show_upgrade_button",
    "upgrade_price",
    "upgraded_to_pro",
    "upgrade_to_pro",
    "downgrade_to_standard",
    "variant"
  ],
  data() {
    return {
      minimum_quantity: this.min_limit || 0,
      maximum_quantity: this.limit || 10,
      hidden: false,
      show_upgrade_details_modal: false,
    };
  },
  computed: {
    added_this_arsenal() {
      return this.arsenal.quantity > 0 || this.arsenal.cables.length > 0;
    },
    show_retail_price() {
      if (this.show_upgrade_button && this.arsenal_model == 'Pro') {
        return false
      }
      return this.prices.sale < this.prices.retail
    },
    show_add_product_button() {
      if (this.show_upgrade_button) {
        return false
      }
      return this.maximum_quantity > 1
    },
    product_name() {
      if (this.arsenal_model == 'Pro') return 'Arsenal 2 Pro'
      return 'Arsenal 2'
    },
  },
  methods: {
    format_currency,
    open_upgrade_details_modal() {
      this.show_upgrade_details_modal = true
    },
    close_upgrade_details_modal() {
      this.show_upgrade_details_modal = false
    },
    upgrade_and_close_modal() {
      this.upgrade_to_pro()
      this.close_upgrade_details_modal()
    },
    update_arsenal_quantity(val) {
      if (val < this.minimum_quantity) val = this.minimum_quantity;
      if (val > this.maximum_quantity) val = this.maximum_quantity;

      // unflag this arsenal as having been prepopulated by
      // query params (e.g. ?arsenal_pro=1)
      if (val == 0) {
        // TODO: Do we want to show both Arsenal 2 and 2 Pro
        // when they reduce the quantity of the preselected one to zero?
        // If so, uncomment below
        // this.arsenal.prepopulated = false;
      }

      if (val < this.arsenal.quantity) {
        if (this.arsenal.cables[this.arsenal.cables.length - 1] == "") {
          this.arsenal.cables.pop();
        }
      }
      this.arsenal.quantity = val;
      const number_of_cables_to_add = max([
        this.arsenal.quantity - this.arsenal.cables.length,
        0,
      ]);
      times(number_of_cables_to_add, () => this.arsenal.cables.push(""));
    },
  },
  components: { ProductDetailsModal, AddProductButton, Cables },
};
</script>
